export const EMPTY_VALUE = "";

const formatArrayValue = (arr) => {
  if (!Array.isArray(arr) || arr.length === 0) return EMPTY_VALUE;
  return (
    arr
      .map((item) => {
        if (item === null || item === undefined) return "";
        if (typeof item === "object") {
          return (
            item?.productName ||
            item?.serviceName ||
            item?.engagementLevelName ||
            item?.intentLevelName ||
            item?.name ||
            item?.label ||
            item?.value ||
            JSON.stringify(item)
          );
        }
        return String(item).trim();
      })
      .filter(Boolean)
      .join(", ") || EMPTY_VALUE
  );
};

export const getValue = (value) => {
  if (value === null || value === undefined || value === "") return EMPTY_VALUE;

  if (Array.isArray(value)) {
    return formatArrayValue(value);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return formatArrayValue(parsed);
        }
      } catch {
        // Fall back
      }
    }
  }

  return value;
};
const getCurrecyValue = (currencyCode, currencyValue) => {
  return currencyValue ? `${currencyCode || ""} ${currencyValue || ""}` : ""
}
export const getBasicInformationView = (data = {}) => {

  const reasonValue = getValue(
    typeof data?.reason === "object" && data?.reason !== null
      ? data?.reason?.disqualificationReason ||
      data?.reason?.nurtureReason ||
      data?.reason?.reason ||
      data?.reason?.name
      : data?.reason
  );

  return {
    left: [
      { label: "Business Profile", value: getValue(data?.businessProfile) },
      { label: "Website", value: getValue(data?.organizationWebsite) },

      { label: "Geography", value: getValue(data?.geography) },
      { label: "Country", value: getValue(data?.country) },
      { label: "State", value: getValue(data?.state) },
    ],
    right: [
      { label: "Qualification Readiness", value: getValue(data?.qualificationReadiness) },
      { label: "Industry", value: getValue(data?.industry) },
      { label: "Company Size", value: getValue(data?.companySize) },
      { label: "Reason", value: reasonValue },
    ],
    fullWidth: [

      { label: "Description", value: getValue(data?.prospectDescription) },
      { label: "Note", value: getValue(data?.note) },
    ],
  };
};

export const getProspectInterestView = (data = {}) => ({
  left: [
    {
      label: "Interested Product",
      value: getValue(data?.interestedProduct || data?.products),
    },
    {
      label: "Interested Service",
      value: getValue(data?.interestedService || data?.services),
    },
    {
      label: "Business Value",
      value: getCurrecyValue(data?.customerCurrency?.currencyCode, data?.potentialBusinessValue),
    },
    { label: "Notes", value: getValue(data?.notes || data?.note) },
  ],
});

export const getProspectQualificationView = (data = {}) => ({
  left: [
    {
      label: "ICP Fit Score",
      value: getValue(data?.ICPfitScore || data?.icpFitScore),
    },
    {
      label: "Engagement Level",
      value: getValue(
        data?.engagementLevel?.engagementLevelName ||
        data?.engagementLevel?.engagementLevel ||
        data?.engagementLevel?.name ||
        data?.engagementLevel
      ),
    },
    {
      label: "Intent Score",
      value: getValue(data?.buyingIntentScore),
    },
  ],
  right: [
    {
      label: "Overall Score",
      value: getValue(data?.overallProspectScore),
    },
    {
      label: "Intent Level",
      value: getValue(
        data?.buyingIntentLevel?.intentLevelName ||
        data?.buyingIntentLevel?.intentLevel ||
        data?.buyingIntentLevel?.name ||
        data?.buyingIntentLevel
      ),
    },
  ],
  fullWidth: [],
});

export const getProspectSourceView = (data = {}) => ({
  left: [
    {
      label: "Prospect Source",
      value: getValue(
        data?.prospectSource?.sourceName ||
        data?.prospectSource?.name ||
        data?.prospectSource
      ),
    },
    {
      label: "URL",
      value: getValue(data?.landingPageUrl),
    },
    {
      label: "Prospect Medium",
      value: getValue(data?.prospectMedium),
    },
  ],
  right: [],
  fullWidth: [],
});
